<a class="article-link" (click)="viewDetails(); $event.stopPropagation()">
  <ng-container *ngIf="imagePhoto && imagePhoto.length > 0; then ImageLayout else TextLayout"></ng-container>
  <ng-template #ImageLayout>
    <div a11y_Button artikleLabelHeight class="articleCard articleCard--has-image">
      <ng-container *ngIf="imagePhoto && imagePhoto.length > 0">
        <div class="image-container">
          <div class="aspect-ratio-box">
            <div class="aspect-ratio-box-inside">
              <div class="aspect-ration-img-box">
                <img class="ya_image" [src]="imagePhoto" alt="" (error)="onImageError()" />
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <div class="content-container">
        <div class="product-label-content">
          <h3>{{product.label}}</h3>
        </div>
        <ng-container *ngIf="hasTag">
          <div class="item-tag-container">
            <div class="item-tag-wrapper">
              <ng-container *ngIf="itemTagType === tagType.Icon; then iconTagTemplate else textTagTemplate">
              </ng-container>
              <ng-template #iconTagTemplate>
                <ng-container *ngFor="let itemTag of product.itemTags">
                  <div class="inline-icon" [innerHTML]="svgSanitizer(itemTag.svgIcon, itemTag.color)"></div>
                </ng-container>
              </ng-template>
              <ng-template #textTagTemplate>
                <ng-container *ngFor="let itemTag of product.itemTags">
                  <span>{{itemTag.label}}</span>
                </ng-container>
              </ng-template>
            </div>
            <div class="gradient"></div>
          </div>
        </ng-container>
        <div class="product-content-info">
          <ng-container *ngIf="deposit > 0">
            <div class="deposit">
              <span [langkey]="includeDeposit ? 'phWebshop_includeDeposit' : 'phWebshop_plusDeposit'"></span>
              <span class="deposit-value">{{priceFormatter(deposit)}}</span>
            </div>
          </ng-container>
          <ng-container *ngIf="useECommerce && !product.is_recipe_linking">
            <div class="product-content-value">
              <ng-container *ngIf="hasCaffeineLevel|| hasAlcoholLevel">
                <span class="level-value" *ngIf="hasCaffeineLevel">{{CaffeinelevelText}}</span>
                <span class="level-value" *ngIf="hasAlcoholLevel">{{AlcohollevelText}}</span>
              </ng-container>
            </div>
          </ng-container>
          <ng-container *ngIf="hasBaseUnit">
            <span>{{baseUnit}}</span>
          </ng-container>
        </div>
        <ng-container *ngIf="useECommerce && prepackaged">
          <span langkey="phProductDetail_prepackaged"></span>
        </ng-container>
        <div class="content-lower-bar">
          <a class="content-lower-bar__clickable" (click)="viewDetails(); $event.stopPropagation()">
            <ng-container *ngIf="product.is_recipe_linking">
              <span langkey="phArticleCard_Recipe_Price_from"></span>
            </ng-container>
            <div class="price-container">
              <ng-container *ngIf="standartPrice > finalPrice">
                <div class="oldprice">{{priceFormatter( getDisplayedStandartPrice() )}}</div>
              </ng-container>
              <div class="product-price">
                <div class="finalprice">{{priceFormatter( getDisplayedFinalPrice() )}}</div>
              </div>
            </div>
            <div class="product-action-btn">
              <div class="inline-icon action-icon rotateRight" inlineSVG="shop-icons.svg#ya-hypersoft-pfeil-oben-voll">
              </div>
            </div>
          </a>
        </div>
      </div>
      <ng-container *ngIf="!product.availible">
        <div class="product-unavailableoverlay">
          <div class="text-container">
            <span>{{product.schedule_hint}}</span>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="product.availible && !isAvailable">
        <div class="product-unavailableoverlay">
          <div class="text-container">
            <span langkey="phArticleCard_ArticleUnavailable"></span>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-template>
  <ng-template #TextLayout>
    <div a11y_Button class="articleCard articleCard--no-image">
      <div class="content-container" [class.nodescription]="!description || description.trim().length == 0">
        <div class="product-label-content">
          <h3>{{product.label}}</h3>
        </div>
        <ng-container *ngIf="description && description.trim().length > 0">
          <div #descriptionDiv class="description">
            <p #descriptionTextDiv
              [ngClass]="activeEllipse ? ['description-text', 'description-text-ellipse']:'description-text'">
              {{description}}
            </p>
          </div>
        </ng-container>
        <div class="item-tag-container">
          <div class="item-tag-wrapper">
            <ng-container *ngIf="itemTagType === tagType.Icon; then iconTagTemplate else textTagTemplate">
            </ng-container>
            <ng-template #iconTagTemplate>
              <ng-container *ngFor="let itemTag of product.itemTags">
                <div class="inline-icon" [innerHTML]="svgSanitizer(itemTag.svgIcon, itemTag.color)"></div>
              </ng-container>
            </ng-template>
            <ng-template #textTagTemplate>
              <ng-container *ngFor="let itemTag of product.itemTags">
                <span>{{itemTag.label}}</span>
              </ng-container>
            </ng-template>
          </div>
        </div>
        <div class="product-content-info">
          <ng-container *ngIf="deposit > 0">
            <div class="deposit">
              <span [langkey]="includeDeposit ? 'phWebshop_includeDeposit' : 'phWebshop_plusDeposit'"></span>
              <span class="deposit-value">{{priceFormatter(deposit)}}</span>
            </div>
          </ng-container>
          <ng-container *ngIf="useECommerce">
            <div class="product-content-value">
              <ng-container *ngIf="hasCaffeineLevel|| hasAlcoholLevel">
                <span class="level-value" *ngIf="hasCaffeineLevel">{{CaffeinelevelText}}</span>
                <span class="level-value" *ngIf="hasAlcoholLevel">{{AlcohollevelText}}</span>
              </ng-container>
            </div>
          </ng-container>
          <ng-container *ngIf="hasBaseUnit">
            <span>{{baseUnit}}</span>
          </ng-container>
          <ng-container *ngIf="useECommerce && prepackaged">
            <span langkey="phProductDetail_prepackaged"></span>
          </ng-container>
        </div>
        <div class="content-lower-bar ">
          <a class="content-lower-bar__clickable" (click)="viewDetails(); $event.stopPropagation()">
            <ng-container *ngIf="product.is_recipe_linking">
              <span langkey="phArticleCard_Recipe_Price_from"></span>
            </ng-container>
            <div class="price-container">
              <ng-container *ngIf="standartPrice > finalPrice">
                <div class="oldprice">{{priceFormatter( getDisplayedStandartPrice() )}}</div>
              </ng-container>
              <div class="product-price">
                <div class="finalprice">{{priceFormatter( getDisplayedFinalPrice() )}}</div>
              </div>
            </div>
            <div class="product-action-btn">
              <div class="inline-icon action-icon rotateRight" inlineSVG="shop-icons.svg#ya-hypersoft-pfeil-oben-voll">
              </div>
            </div>
          </a>
        </div>
      </div>
      <ng-container *ngIf="!product.availible">
        <div class="product-unavailableoverlay">
          <div class="text-container">
            <span>{{product.schedule_hint}}</span>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="product.availible && !isAvailable">
        <div class="product-unavailableoverlay">
          <div class="text-container">
            <span langkey="phArticleCard_ArticleUnavailable"></span>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-template>
</a>